import { Component, Input, ViewChild, ViewContainerRef, inject } from '@angular/core';
import { IDroppedFile } from '@shared/ui-components/au-file-loader/au-file-loader.interfaces';
import { fileTypesConfig } from '@shared/ui-components/au-file-loader/au-file-loader.config';
import { updateActiveTab } from '@app/pages/cmms/components/files/state/files.action';
import { Store } from '@ngrx/store';
import { MatIconModule } from '@angular/material/icon';
import { SanitizeUrlPipe } from '../../helpers/sanitize-url.pipe';
import { NgxDocViewerModule } from 'ngx-doc-viewer';

import { NgxTolgeeModule } from '@tolgee/ngx';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FileFormatContentTypeMap } from '../../helpers/file-utilities';

const formatsSupportedByOfficeEngine: FileFormatContentTypeMap[] = [
	FileFormatContentTypeMap.DOC,
	FileFormatContentTypeMap.DOCX,
	FileFormatContentTypeMap.XLS,
	FileFormatContentTypeMap.XLSX,
	FileFormatContentTypeMap.PPT,
	FileFormatContentTypeMap.PPTX,
];
const formatsSupportedByGoogleEngine: FileFormatContentTypeMap[] = [
	FileFormatContentTypeMap.TXT,
];

export enum CurrentFileType {
	IMAGE = 'image',
	PDF = 'pdf',
	DOCUMENT = 'document',
	UNSUPPORTED = 'unsupported',
	PRESENTATION = 'presentation',
	VIDEO = 'video',
	CAD = 'cad',
	GOOGLE_SUPPORTED = 'google-supported',
}

@Component({
	selector: 'au-file-viewer',
	templateUrl: './file-viewer.component.html',
	styleUrls: ['./file-viewer.component.scss'],
	imports: [
		MatIconModule,
		SanitizeUrlPipe,
		NgxDocViewerModule,
		NgxTolgeeModule,
		MatTooltipModule,
	],
})
export class FileViewerComponent {
	private readonly store$ = inject(Store);
	// TODO this is strange. Just find out why it was data.url and now - data.file.url and refactor it
	// this is not necessary functionality. Just backward compatibility with some legacy stuff.
	@Input() fileEntityPk: string;
	@Input() set fileData(data: Partial<IDroppedFile>) {
		this.file = {
			// its ignored because clearly here a mistake in typings. I leaved a commend there. TODO find out and refactor
			// @ts-ignore
			contentType: data.contentType || data.file?.contentType,
			name: data.name || data.file?.name,
			// @ts-ignore
			url: data.url || data.file?.url,
		};
		this.fileType = this.getCurrentFileType();
		if (this.fileEntityPk) {
			this.store$.dispatch(
				updateActiveTab({ fileId: this.fileEntityPk, activeTab: 'view' })
			);
		}
	}

	file: {
		contentType: string;
		name: string;
		url: string;
	};

	@ViewChild('fileViewerComponent', { read: ViewContainerRef })
	private fileViewerComponent: ViewContainerRef;
	supportedImageFormats: string[] = [
		FileFormatContentTypeMap.JPEG,
		FileFormatContentTypeMap.PNG,
		FileFormatContentTypeMap.WEBP,
	];

	fileType: CurrentFileType;

	private getCurrentFileType(): CurrentFileType {
		const contentType = this.file.contentType as FileFormatContentTypeMap;

		if (
			contentType === FileFormatContentTypeMap.JPEG ||
			contentType === FileFormatContentTypeMap.PNG ||
			contentType === FileFormatContentTypeMap.GIF ||
			contentType === FileFormatContentTypeMap.WEBP
		) {
			return CurrentFileType.IMAGE;
		}
		if (contentType === FileFormatContentTypeMap.PDF) {
			return CurrentFileType.PDF;
		}
		if (formatsSupportedByOfficeEngine.includes(contentType)) {
			return CurrentFileType.DOCUMENT;
		}
		if (fileTypesConfig.video.supportedFormatsList.includes(contentType)) {
			return CurrentFileType.VIDEO;
		}
		if (fileTypesConfig.presentation.supportedFormatsList.includes(contentType)) {
			return CurrentFileType.PRESENTATION;
		}
		if (fileTypesConfig.cad.supportedFormatsList.includes(contentType)) {
			return CurrentFileType.CAD;
		}
		if (formatsSupportedByGoogleEngine.includes(contentType)) {
			return CurrentFileType.GOOGLE_SUPPORTED;
		}
		return CurrentFileType.UNSUPPORTED;
	}

	goFullscreen() {
		const elem = this.fileViewerComponent.element.nativeElement;

		if (elem.requestFullscreen) {
			elem.requestFullscreen();
		} else if (elem.webkitRequestFullscreen) {
			/* Safari */
			elem.webkitRequestFullscreen();
		} else if (elem.msRequestFullscreen) {
			/* IE11 */
			elem.msRequestFullscreen();
		}
	}
	openNewTab() {
		window.open(this.file.url, '_blank');
	}
}
